import awsdk from 'awsdk';
import { Pharmacy, Consumer, State } from 'lib/amwell/sdk/types';
import BaseService from './BaseService';
import AwsdkError from '../errors/AwsdkError';

export default class PharmacyService extends BaseService {
  async searchPharmacies(
    city: string,
    state: State,
    zipCode: string,
    pharmacyType: 'RETAIL' | 'MAIL_ORDERS'
  ): Promise<Pharmacy[]> {
    const key = this.searchPharmacies.name;

    try {
      return await this.sdk.pharmacyService.getPharmacies(city, state, zipCode, pharmacyType);
    } catch (err) {
      throw new AwsdkError(key, err);
    }
  }

  async getAllPharmacies(
    latitude: number,
    longitude: number,
    radius: number,
    pharmacyType: 'RETAIL' | 'MAIL_ORDERS'
  ): Promise<Pharmacy[]> {
    const key = this.getAllPharmacies.name;

    try {
      return await this.sdk.pharmacyService.getPharmaciesByLongitudeAndLatitude(
        longitude,
        latitude,
        radius,
        pharmacyType === 'RETAIL'
      );
    } catch (err) {
      throw new AwsdkError(key, err);
    }
  }

  async updatePreferredPharmacy(consumer: Consumer, pharmacy: Pharmacy): Promise<Consumer> {
    const key = this.updatePreferredPharmacy.name;

    try {
      return await this.sdk.pharmacyService.updatePreferredPharmacy(consumer, pharmacy);
    } catch (err) {
      throw new AwsdkError(key, err);
    }
  }

  async getPreferredPharmacy(consumer: Consumer): Promise<Pharmacy | null> {
    const key = this.getPreferredPharmacy.name;

    try {
      return await this.sdk.pharmacyService.getPreferredPharmacy(consumer);
    } catch (err) {
      if (
        err instanceof awsdk.AWSDKError &&
        err.errorCode === awsdk.AWSDKErrorCode.noPreferredPharmacyFound
      ) {
        return null;
      }
      throw new AwsdkError(key, err);
    }
  }
}
